import {
    setSelectedView, setSearchType, setStatsName, setFilters, setTilePagination, setGridPagination, setListPagination, setLoadMapView, setMapMetaData, setLoadPerfChartView, setApplyClick
} from './actions';

 
const dispatchSelectedView = (dispatch:any) => (param:any) =>{
    dispatch(setSelectedView(param));
}
const dispatchSearchType = (dispatch: any) => (param: any) => {
    dispatch(setSearchType(param));
}
const dispatchStatsName = (dispatch: any) => (param: any) => {
    dispatch(setStatsName(param));
}
const dispatchFilters = (dispatch: any) => (param: any) => {
    dispatch(setFilters(param));
}
const dispatchTilePagination = (dispatch: any) => (param: any) => {
    dispatch(setTilePagination(param));
}
const dispatchGridPagination = (dispatch: any) => (param: any) => {
    dispatch(setGridPagination(param));
}
const dispatchListPagination = (dispatch: any) => (param: any) => {
    dispatch(setListPagination(param));
}
const dispatchLoadMapView = (dispatch: any) => (param: any) => {
    dispatch(setLoadMapView(param));
}
const dispatchMapMetaData = (dispatch: any) => (param: any) => {
    dispatch(setMapMetaData(param));
}
const dispatchLoadPerfChartView = (dispatch: any) => (param: any) => {
    dispatch(setLoadPerfChartView(param));
}
const dispatchApplyClick = (dispatch: any) => (param: any) => {
    dispatch(setApplyClick(param));
}
const operations = {
    dispatchSelectedView,
    dispatchSearchType,
    dispatchStatsName,
    dispatchFilters,
    dispatchTilePagination,
    dispatchGridPagination,
    dispatchListPagination,
    dispatchLoadMapView,
    dispatchMapMetaData,
    dispatchLoadPerfChartView,
    dispatchApplyClick
};

export default operations;
